jQuery(document).ready(
    function(){
     setTimeout(
       function(){
    jQuery('li.wishl-tab.wishl-controls-your-lists').text('Your Project Boards');
    jQuery('li.wishl-tab.wishl-controls-new-list').text('New Project Board');
    jQuery('.template-page div#wishl-controls').show();
         console.log('changed');},1000)
    }
  );
  // designer read more toggle
  jQuery('#designer-read-more-toggle').on('click',function(){
  jQuery(this).toggleClass('show-less');
  jQuery('.product-designer-text').toggleClass('show-less');
    if(jQuery(this).hasClass('show-less')){
      jQuery(this).text('- Show Less');
    }
    else{
    jQuery(this).text('+ Read More');
    }
  });
  //products measurement toggle
  jQuery('#measurements-toggle').on('click',function(){
    if(jQuery(this).text() == 'Show Imperial'){
      jQuery(this).text('Show Metric');
    }
    else{
    jQuery(this).text('Show Imperial');
    }
    jQuery('.custom-field__dimensions-metric').toggle();
    jQuery('.custom-field__dimensions-imperial').toggle();

  });